import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var LeftPadPipe = (function () {
    function LeftPadPipe() {
    }
    LeftPadPipe.prototype.transform = function (str, length, padCharacter) {
        if (padCharacter === void 0) { padCharacter = ' '; }
        if (!isString(str) || str.length >= length) {
            return str;
        }
        while (str.length < length) {
            str = padCharacter + str;
        }
        return str;
    };
    return LeftPadPipe;
}());
export { LeftPadPipe };
LeftPadPipe.decorators = [
    { type: Pipe, args: [{ name: 'lpad' },] },
];
/** @nocollapse */
LeftPadPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=lpad.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/lpad.js
// module id = 259
// module chunks = 4